
import Toaster from '../helpers/Toaster'

export default class ExceptionHandling {

	static HandleErrors(error) {

		if([400, 401, 403, 404, 502].includes(error.status)){
			// const answer = window.confirm("Your are not logged in, Do you want to go to login?");
			// if (answer) {
			// 	window.location.href = '/login';
			// } else {
			//   // do nothing
			// }
		} else {

			const toaster = new Toaster();

			toaster.showError(error?.data?.message ?? 'System Error');
		}
	}
}